<template>
    <page>
        <div class="shadow-1" style="height:100vh;background-color:#FFFFFF;">
            <div class="column full-height justify-center items-center">
                <v-header :title="$t('identify yourself')" icon="lock open"></v-header>
                <card v-if="loginEnabled" footer-color="secondary">

                    <transition name="page" mode="out-in">
                        <template v-if="!user">
                            <form @submit.prevent="login"
                                class="gutter-xs q-pt-xs"
                                ref="fform"
                                @keydown="form.onKeydown($event)">

                                <div v-if="authSource === 'LDAP'">
                                    <v-input path="username"
                                            v-model="form.username"
                                            :label="$t('username')"
                                            clearable
                                            :form="form"
                                            class="login-fields">
                                    </v-input>

                                    <v-input path="password"
                                            v-model="form.password"
                                            :label="$t('password')"
                                            type="password"
                                            clearable
                                            :form="form"
                                             class="login-fields">
                                    </v-input>
                                </div>
                            
                                <v-select path="auth_source"
                                        v-if="IMDLEnabled"
                                        v-model="authSource"
                                        :label="$t('auth source')"
                                        :options="authSources"
                                        :clearable="false"
                                        :form="form"
                                        class="col-md-4 col-sm-6 col-xs-12">
                                </v-select>

                                <div class="row justify-center q-mt-md">
                                    <v-button 
                                            :label="$t('log in')"
                                            class="no-shadow q-btn-iqos"
                                            :loading="form.busy"
                                            type="submit">
                                        <template slot="loading">
                                            <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                            {{ $t('validating...') | capitalize }}
                                        </template>
                                    </v-button>
                                    <br>

                                    <v-button flat color="highlight" @click="remember"
                                            class="full-width col-12 q-mt-xs"
                                            :label="$T('forgot your password?')"></v-button>
                                </div>

                            </form>

                            <template slot="actions">

                            </template>
                        </template>

                        <div v-else class="q-pa-xl text-center">
                            {{ $T('you are logged in!') }}
                        </div>
                    </transition>

                </card>
                <div class="row justify-center q-mt-md">
                    <v-button outline
                        v-if="SSOEnabled"
                        :label="$t('SSO Login')"
                        color="highlight"
                        @click="ssologin"
                        class="no-shadow uppercase q-btn-iqos">
                    </v-button>
                </div>

            </div>
        </div>
    </page>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Form from 'vform'
    import {QDialog, QSpinnerPuff, openURL} from 'quasar-framework'
    import axios from "axios"

    export default {
        middleware: 'guest',
        layout: 'basic',

        metaInfo() {
            return {title: this.$T('log in')}
        },

        components: {
            QSpinnerPuff,
            QDialog
        },

        data: () => ({
            form: new Form({
                username: '',
                password: '',
                domain: 1,
                remember: false
            }),
            authSources: [{label: 'IMDL', value: 'IMDL'}, {label: 'LDAP', value: 'LDAP'}],
            authSource: 'LDAP',
            IMDLEnabled: false,
            SSOEnabled:  window.config.ssoLoginEnabled,
            SSOError: null,
            loginEnabled: window.config.loginEnabled,
        }),
        mounted() {
            if (this.SSOError) {
            this.notify(this.$t('error'), this.SSOError, [], 'negative');
            }
        },

        created() {
            const urlParams = new URLSearchParams(window.location.search);
            this.SSOError = urlParams.get('SSOError');

            if (this.$route.query.token) {
                // Save the token.
                this.$store.dispatch('auth/saveToken', {
                    token: this.$route.query.token,
                })

                this.$store.dispatch('auth/fetchUser')

                this.$router.push({name: 'home'})

            }
            this.IMDLEnabled = window.config.IMDL
        },

        computed: {
            ...mapGetters({
                user: 'auth/user'
            })
        },

        methods: {
            notify(message, detail, actions = [], type = 'positive') {
                this.$q.notify({
                    type,
                    position: 'top',
                    message,
                    detail,
                    timeout: 10000,
                    actions
                })
            },
            async login() {
                if (this.authSource === 'IMDL') {
                    this.$refs.fform.method = 'POST'
                    this.$refs.fform.action = '/login/imdl'
                    this.$refs.fform.submit()
                    return
                }
                // Submit the form.
                const {data} = await this.form.post(`${config.appUrl}/api/login`)

                // Error
                if (data.errorCode && data.errorCode === 4002) {
                    // Redirect home.
                    this.$router.push({name: 'error-4002'})
                    return
                }

                // Save the token.
                this.$store.dispatch('auth/saveToken', {
                    token: data.token,
                    remember: this.form.remember
                })
                // Fetch the user.
                await this.$store.dispatch('auth/fetchUser')

                // Wrong market for user
                if(this.user.market.abbreviation !== window.config.market){
                    this.$router.push({name: 'error-4004'})
                    return
                }

                // No lending point?
                if (this.user.missing_lending_point) {
                    // Redirect home.
                    this.$router.push({name: 'error-4001'})
                    return
                }

                // Redirect home or 2fa.
                this.$router.push({name: 'home'})
            },

            remember() {
                openURL(window.config.passwordResetUrl)
            },
            
            ssologin() {
                window.location.href = window.config.ssoLogin;
            }
        }
    }
</script>

<style>
.login-fields .q-if-error:before, .q-if-error:after, .q-if-error:not(.q-if-inverted) .q-if-label {
    color: #524F5A !important;
}

.login-fields .q-if-label {
    color: #524F5A !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/login.vue